import { useState } from "react";
import axios from "axios";

function AddClient({ onClose }) {

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [companyName, setCompanyName] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [mobile, setMobile] = useState("");
    const [address, setAddress] = useState("");

    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [pinCode, setPinCode] = useState("");

    const saveClient = async (e) => {

        e.preventDefault();

        try {

            const token = localStorage.getItem("token");

            const response = await axios.post("https://saleupcall.com/api/Client/add-client.php",
                {
                    username,
                    email,
                    password,
                    company_name: companyName,
                    contact_person: contactPerson,
                    mobile,
                    address,
                    city,
                    state,
                    pin_code: pinCode
                },
                { headers: { Authorization: `Bearer ${token}` } });

            if (response.data.status) {
                alert("Client Added");
                setUsername("");
                setEmail("");
                setPassword("");
                setCompanyName("");
                setContactPerson("");
                setMobile("");
                setAddress("");
                setCity("");
                setState("");
                setPinCode("");
                if (onClose) {
                    onClose();
                }
            }
            else {
                alert(response.data.message);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    return (
        <form onSubmit={saveClient}>
            <h5 className="mb-3">Login Details</h5>
            <div className="row">
                <div className="col-md-4 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
                </div>
                <div className="col-md-4 mb-2">
                    <input type="email" className="form-control form-control-sm" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="col-md-4 mb-2">
                    <input type="password" className="form-control form-control-sm" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </div>
            </div>
            <hr />
            <h5 className="mb-3">Other Details</h5>
            <div className="row">
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Company Name" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                </div>
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Contact Person" value={contactPerson} onChange={(e) => setContactPerson(e.target.value)} />
                </div>
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} />
                </div>
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} />
                </div>
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="State" value={state} onChange={(e) => setState(e.target.value)} />
                </div>
                <div className="col-md-6 mb-2">
                    <input type="text" className="form-control form-control-sm" placeholder="Pin Code" value={pinCode} onChange={(e) => setPinCode(e.target.value)} />
                </div>
                <div className="col-md-12 mb-2">
                    <textarea className="form-control form-control-sm" rows="2" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} />
                </div>
            </div>
            <div className="text-end mt-1">
                <button type="submit" className="btn btn-primary btn-sm">
                    <i className="bi bi-check-lg me-1"></i>
                    Save Client
                </button>
            </div>
        </form>

    );

}

export default AddClient;